import { render, staticRenderFns } from "./EventSection.vue?vue&type=template&id=55435c28&scoped=true"
import script from "./EventSection.vue?vue&type=script&lang=js"
export * from "./EventSection.vue?vue&type=script&lang=js"
import style0 from "./EventSection.vue?vue&type=style&index=0&id=55435c28&prod&lang=scss&scoped=true"
import style1 from "./EventSection.vue?vue&type=style&index=1&id=55435c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55435c28",
  null
  
)

export default component.exports